// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import iview from 'iview'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import App from './App'
import plugins from 'base/js/plugins';
import "babel-polyfill";


Vue.use(iView);
Vue.use(plugins)

import router from './router'
import 'base/js/http'

Vue.config.productionTip = false

router.afterEach((to,from,next) => {
  window.scrollTo(0,0);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js